import React from 'react'
import { Link } from 'react-router-dom'
import {MdKeyboardArrowDown} from 'react-icons/md'
import {CiFacebook,CiTwitter,CiInstagram,CiLinkedin,CiLock} from  'react-icons/ci'
import { styled } from 'styled-components'
import useScreenSize from '../hooks/useScreenSize'

const FooterSection = () => {
  let {width} = useScreenSize();
  
  const handleFooterLinkOpen = (e) => {
    if(width > 800) return;

    const linksContent = e.target.nextElementSibling;
    const arrowIcon = e.target.children[0];

    linksContent?.classList.toggle("link-content-open");

    linksContent?.classList.contains("link-content-open") ? arrowIcon.style.transform = "rotate(180deg)" : arrowIcon.style.transform = "rotate(0deg)";

  }

  return (
    <Container>
      <div className="footer-links-content-container">
        <div className="footer-links-content">
          <div className="footer-content-info">
            <h2>AMRS</h2>
            <p>Explore our website to delve deeper into each of these areas and discover how we're shaping the future of engineering education, research, and inclusivity.</p>
          </div>
          <div className='links-content-container'>
            <div className="links-content">
              <h6 onClick={handleFooterLinkOpen}>Meetings & Events {width < 800 ? <MdKeyboardArrowDown />:""}</h6>
              <ul>
                <li><Link to="/">Upcoming Meetings<CiLock size={12}/></Link></li>
                <li><Link to="/">AMRS Conference Service<CiLock size={12}/></Link></li>
                <li><Link to="/">Meeting Calendar<CiLock size={12}/></Link></li>
                <li><Link to="/">Meeting Scene<CiLock size={12}/></Link></li>
              </ul>  
            </div>
            <div className="links-content">
              <h6 onClick={handleFooterLinkOpen}>Publications & News  {width < 800 ? <MdKeyboardArrowDown />:""}</h6>
              <ul>
                <li><Link to="/">Journals<CiLock size={12}/></Link></li>
                <li><Link to="/">Books & Textbooks<CiLock size={12}/></Link></li>
                <li><Link to="/">AMRS Publishing<CiLock size={12}/></Link></li>
                <li><Link to="/news">News</Link></li>
              </ul>  
            </div>
            <div className="links-content">
              <h6 onClick={handleFooterLinkOpen}>Programs & Outreaches  {width < 800 ? <MdKeyboardArrowDown />:""}</h6>
              <ul>
                <li><Link to="/">Education and Public Outreach<CiLock size={12}/></Link></li>
                <li><Link to="/">Science as Art<CiLock size={12}/></Link></li>
                <li><Link to="/">University Chapters<CiLock size={12}/></Link></li>
              </ul>  
            </div>
            {/*<div className="links-content">
              <h6 onClick={handleFooterLinkOpen}>AMRS Chapters  {width < 800 ? <MdKeyboardArrowDown />:""}</h6>
              <ul>
                <li><Link to="/ug-chapter">UG-Chapter</Link></li>
                <li><Link to="/ucc-chapter">UCC-Chapter</Link></li>
                <li><Link to="/knust-chapter">KNUST-Chapter</Link></li>
                <li><Link to="/uds-chapter">UDS-Chapter</Link></li>
              </ul>  
            </div>*/}
            <div className="links-content">
              <h6 onClick={handleFooterLinkOpen}>About AMRS {width < 800 ? <MdKeyboardArrowDown />:""}</h6>
              <ul>
                <li><Link to="/">Membership<CiLock size={12}/> </Link></li>
                <li><Link to="/">The Society<CiLock size={12}/></Link></li>
                <li><Link to="/">Marketing Opportunities<CiLock size={12}/></Link></li>
                <li><Link to="/">Volunteer with AMRS<CiLock size={12}/></Link></li>
              </ul>  
            </div>
          </div>
        </div>  
      </div>
      <div className="footer-end-info-container">
        <div className="footer-end-icons">
          {/* <Link to="" ><CiFacebook /></Link> */}
          <Link to="https://x.com/amrs_ghana"><CiTwitter/></Link>
          <Link to="https://www.instagram.com/amrs_ghana/"><CiInstagram/></Link>
          {/* <Link to=""><CiLinkedin/></Link> */}

        </div>
        <div className="footer-end-info">
          <Link to="/legal/terms-of-use">Terms of Use</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <p>© 2023 AMRS. All rights reserved.</p>
        </div>
      </div>
    </Container>
  )
}

const Container = styled.footer`
  .footer-links-content-container{
    padding: 3em 2em;
    .footer-content-info{
      margin-bottom: 5em;
      p{
        font-size: 1rem;
        letter-spacing: 1px;
      }
    }
    .links-content{
      padding:1em 0;
      &:not(:last-child){
        border-bottom: 1px solid var(--color-muted-black-light);
      }
      h6{
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-weight: 400;
        font-size: 1.2rem;
        padding:0.6em 0;
        margin: 0;
        cursor: pointer;
        svg{
          /* assigned z-index property of svg to prevent it from being clicked by client that results in an error */
          z-index: -1;
        }
      }
      .link-content-open{
        display: block;
      }
      ul{
        display: none;
        list-style-type: none;
        padding: 0;
        margin: 0;
        li{
          padding:0.5em 0;
          a{
          font-size: 1rem;
          color: var(--color-muted-black);
          padding: 0.5em 0;
          &:hover{
            color: var(--primary-color);
          }
        }
        }
      }
    }
  }
  .footer-end-info-container{
    border-top: 1px solid var(--color-white-light);
    padding: 2em 2em;
    .footer-end-icons{
      display: flex;
      gap: 2em;
      margin:1em 0;
      a{ 
        &:hover{
          svg{
            color: var(--primary-color);
          }
        }
        svg{
          font-size: 1.5rem;
          color:var(--color-black)
        }
      }
    }
    .footer-end-info{
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      gap: 2em;
      a{
        color: var(--color-black);
        &:hover{
          color: var(--primary-color);
        }
      }
    }
  }

  /* Media Queries */
  @media only screen and (min-width: 800px){
    .footer-links-content-container{
      .footer-links-content{
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: row-reverse;
        .footer-content-info{
          width: 20%;
          margin-left: 1em;
          p{
            letter-spacing: unset;
            font-size: 0.85rem;
            color: var(--color-muted-black);
          }
          h2{
            margin-top: 0.2em
          }
        }
        .links-content-container{
          display: grid;
          gap: 3em;
          grid-template-columns:repeat(5,auto);
          .links-content{
            padding: unset;
            &:not(:last-child){
              border-bottom: unset;
            }
            h6{
              font-size: .85rem;
              font-weight: 500;
              cursor: unset;
            }
            ul{
              display: unset;
              li{
                a{
                  font-size: 0.83rem;
                  color: var(--color-black);
                  &:hover{
                    color: var(--primary-color);
                  }
                }
              }
            }
          }
        }
      }
    }
    .footer-end-info-container{
      display: flex;
      justify-content: space-between;
      .footer-end-info{
        font-size: 0.9rem;
      }
    }
  }

  @media only screen and (min-width: 1200px){
    .footer-links-content-container{
      margin-top: 5em;
    }
  }
`;

export default FooterSection